import React from 'react'

export default function Loader() {
  return (
    <div className='container-fluid'>
      <div className='d-flex justify-content-center align-items-center h-300px'>
        <span className='loadingIcon'>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-loader-2"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 3a9 9 0 1 0 9 9" /></svg>
        </span>
      </div>
    </div>
  )
}
